import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import type { UploadProps } from 'antd';
import { message, Upload } from 'antd';
import uploadImg from '../../assets/player/upload.webp'
import uploadIcon from '../../assets/uploadImg.webp'
import deleteIcon from '../../assets/deleteImg.webp'
import smallUpload from '../../assets/player/smallUpload.webp'
import Cookies from 'js-cookie';
import './Dragger.css'
const { Dragger } = Upload;

// 目标组件的定义
interface MyDraggerProps {
	base64Audio: string;
	setBase64Audio: Dispatch<SetStateAction<string>>;
	fileChangeHook: Function;
	tab?: string;
	type?: string;
	sampleRate?: number;
	setSampleRate?: Dispatch<SetStateAction<number>>;
	disabled?: boolean;
}

const MyDragger: React.FC<MyDraggerProps> = ({ base64Audio, setBase64Audio, fileChangeHook, tab, type, sampleRate, setSampleRate, disabled = false }) => {
	const [audioUrl, setAudioUrl] = useState('');
	const [fileName, setFileName] = useState('')
	const [isLogin, setIsLogin] = useState(!!Cookies.get('access_token'));
	const disabledRef = useRef(disabled);

	useEffect(() => {
		disabledRef.current = disabled;
		if (disabled) {
			setAudioUrl('');
			setFileName('');
			setBase64Audio('');
		}
	}, [disabled, setBase64Audio]);

	const createBase64Audio = (file: Blob) => {
		if (!file || disabledRef.current) return false;
		const reader = new FileReader();

		reader.onload = (event) => {
			if (disabledRef.current) {
				return;
			}
			if (event.target && event.target.result) {
				const base64Data = event.target.result.toString().split(',')[1];

				setBase64Audio(base64Data);


				// 将 Base64 编码的音频数据转换为二进制数据
				const binaryData = atob(base64Data);
				const dataArray = new Uint8Array(binaryData.length);
				for (let i = 0; i < binaryData.length; i++) {
					dataArray[i] = binaryData.charCodeAt(i);
				}
				const arrayBuffer = dataArray.buffer;
				const audioContext = new AudioContext();
				audioContext.decodeAudioData(arrayBuffer, (decodedData) => {
					if (setSampleRate) {
						setSampleRate(decodedData.sampleRate)
					}
				}, (error) => {
					console.error('Error decoding audio data:', error);
				});
			}
		};
		reader.readAsDataURL(file);
		return !!base64Audio;
	};

	const handleUploadFile = (file: Blob) => {
		const audioBlobUrl = URL.createObjectURL(file);
		setAudioUrl(audioBlobUrl);
		createBase64Audio(file);
	};

	const props: UploadProps = {
		name: 'file',
		showUploadList: true,
		multiple: false,
		accept: 'audio/wav',
		onChange(info) {
			const { status } = info.file;
			fileChangeHook();
			if (info.fileList.length > 1) {
				info.fileList.shift();
			}
			if (status !== 'uploading') {
				console.log('files to be upload:', info.file, info.fileList);
			}
			if (status === 'done') {
				setFileName(info.file.name)
				message.success(`${info.file.name} file uploaded successfully.`);
			} else if (status === 'error') {
				message.error(`${info.file.name} file upload failed.`);
			}
		},
		onDrop(e) {
			console.log('Dropped files', e.dataTransfer.files);
		},
		beforeUpload(file) {
			if (disabledRef.current) {
				message.warning('请先阅读并同意语音文件敏感个人信息处理提示');
				return Upload.LIST_IGNORE;
			}
			// 在这里进行文件类型和大小的验证
			const isAudio = file.type.startsWith('audio/');
			if (!isAudio) {
				message.error('只能上传音频文件！');
			}
			// 限制文件大小为28MB
			const isLt28M = file.size / 1024 / 1024 < 28;
			if (!isLt28M) {
				message.error('音频文件大小不能超过28MB！');
			}
			return isAudio && isLt28M;
		},
		customRequest: async ({ file, onSuccess, onError }) => {
			try {
				if (disabledRef.current) {
					throw new Error('未取得敏感个人信息处理同意');
				}
				if (file instanceof Blob) {
					// 如果 file 是 Blob 类型，才执行上传操作
					handleUploadFile(file);
					onSuccess('OK');
				} else {
					// 如果 file 不是 Blob 类型，触发错误
					throw new Error('file 参数不是 Blob 类型');
				}
			} catch (error) {
				console.error('发生错误：', error);
				onError(error);
			}
		},
		onRemove(file) {
			setAudioUrl('');
			setBase64Audio('');
		},
	};

	const handleDivClick = (e: any) => {
		e.stopPropagation(); // 阻止事件冒泡
		// console.log('Div子元素被点击了');
	}
	const tabHeight = () => {
		return tab === 'recognition' ? 476 : 406
	}
	const uploadStyle = {
		height: 93, border: 'none', background: '#E8E8E8', borderRadius: 0
	}
	const draggerStyle = {
		height: tabHeight(), border: 'none', background: '#F6F6F6', borderRadius: 0
	}
	const deleteFile = () => {
		setFileName('')
		setBase64Audio('')
	}
	return (
		<>{fileName
			? <div className='uploadSuccess'>
				<div className='lfet'>
					<img src={uploadIcon} alt="" />
					<span className='fileName'>{fileName}</span>
				</div>
				<div className='right'>
					<span className='success'>上传成功</span>
					<img onClick={deleteFile} style={{ cursor: 'pointer' }} src={deleteIcon} alt="" />
				</div>
			</div>
			: <><Dragger disabled={!isLogin || disabled} itemRender={() => <span></span>} {...props} style={type ? uploadStyle : draggerStyle}>
				{type
					? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						<img src={smallUpload} alt="" />
						<div>
							<p style={{ fontSize: 12, color: '#222222', margin: 0, textAlign: 'left' }} className="ant-upload-text">点击或拖拽音频到此处上传</p>
							<p style={{ fontSize: 12, color: '#999999', margin: 0 }} className="ant-upload-hint">
								支持wav、mp3、m4a格式，文件小于 x M
							</p>
						</div>
					</div>
					: <>
						<p style={{ marginBottom: 12 }} className="ant-upload-drag-icon">
							<img src={uploadImg} alt="" />
						</p>
						<p style={{ fontSize: 12, color: '#222222' }} className="ant-upload-text">点击或拖拽音频到此处上传</p>
						<p style={{ fontSize: 12 }} className="ant-upload-hint">
							支持wav、mp3、m4a格式，文件小于 x M
						</p>

					</>}


			</Dragger></>}</>

	)
};

export default MyDragger;
